<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">{{ title }}</h1>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-col>
        <history-list
          v-if="supplierId"
          :customFilters="historiesFilter"
          refNameColumns="supplierPortalHistoriesColumns"
          refName="supplierPortalHistories"
          :hideFilters="hideFilters"
          :hideColumns="hideColumns"
        ></history-list>
      </v-col>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <pre>{{ supplierId }}</pre>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import HistoryList from "../plugins/histories/HistoryList.vue";
const USER_SUPPLIER = gql`
  query userSupplier($id: ID!) {
    userSupplier: user(id: $id) {
      supplier {
        id
        name
      }
    }
  }
`;
export default {
  components: { HistoryList },
  name: "supplier-portal",

  data() {
    return {
      debug: false,
      hideFilters: ["supplier_name_contains"],
      hideColumns: [
        "totalSell",
        "sellCurrencyCode",
        "isCustomPrice",
        "groupId",
        "itineraryAgentName",
        "totalCostInBase",
        "itineraryNotes",
        "itineraryDestination",
      ],
    };
  },

  computed: {
    title() {
      console.log(this.userSupplier);
      return this.userSupplier
        ? `${this.userSupplier.supplier.name} - Supplier Portal`
        : "Supplier Portal";
    },
    supplierId() {
      return this.userSupplier ? this.userSupplier.supplier.id : null;
    },
    historiesFilter() {
      return { supplier_id: this.supplierId };
    },
  },

  apollo: {
    userSupplier: {
      query: USER_SUPPLIER,
      variables() {
        return {
          id: this.$store.getters.userId,
        };
      },
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/supplier-portal/SupplierPortal.vue